/**
 * Campos que o form edita. O record traz muito mais (`files`, `chainName`,
 * `status`, `exists`…) e o validador Joi do backend recusa chave desconhecida —
 * o que voltaria como "Invalid request payload input", sem dizer qual campo.
 * Por isso o payload é montado por lista branca, não por diff.
 */
export const BRIEFING_FIELDS = [
  'appName',
  'slogan',
  'color',
  'secondaryColor',
  'headerLabelColor',
  'signUpButtonColor',
  'signInButtonColor',
  'briefing',
] as const;

export const toBriefingPayload = (data: Record<string, any>) =>
  Object.fromEntries(
    BRIEFING_FIELDS
      .filter(field => field in data)
      .map(field => [field, data[field] ?? '']),
  );
